import type { DocMigration } from "../docMigration";

function isObject(value: unknown): value is Record<string, any> {
  return value !== null && typeof value === "object";
}

function isFramingLineCondition(edgeOverride: Record<string, any>): boolean {
  const joistAlignment = edgeOverride.joistAlignment;
  if (joistAlignment === "FLUSH_TOP" || joistAlignment === "FLUSH_BOTTOM") {
    return true;
  }
  return joistAlignment === "DROPPED" && edgeOverride.supportFramingCondition === "LAP_JOINT";
}

function migrateSplitLineEdgeOverride(edgeOverride: Record<string, any>): void {
  const edgeType = edgeOverride.edgeType;
  if (edgeType === undefined) {
    return;
  }

  delete edgeOverride.edgeType;

  if (edgeType === "FRAMING_LINE") {
    if (!isFramingLineCondition(edgeOverride)) {
      edgeOverride.joistAlignment = "FLUSH_TOP";
      delete edgeOverride.supportFramingCondition;
    }
    return;
  }

  if (edgeType === "SUPPORT_LINE") {
    edgeOverride.joistAlignment = "DROPPED";
    edgeOverride.supportFramingCondition = "RUN_OVER";
  }
}

const migration: DocMigration = {
  id: "20260514_remove_split_line_edge_type",
  description: "Remove split line edgeType overrides in favor of joist alignment conditions",
  apply(json: any): any {
    const floors: Record<string, any> | undefined = json.floors;
    if (!floors) {
      return json;
    }

    for (const floor of Object.values(floors)) {
      if (!isObject(floor)) {
        continue;
      }

      const splitLines = floor.splitData?.splitLines;
      if (!isObject(splitLines)) {
        continue;
      }

      for (const splitLine of Object.values(splitLines)) {
        if (!isObject(splitLine) || !isObject(splitLine.edgeOverrides)) {
          continue;
        }

        for (const edgeOverride of Object.values(splitLine.edgeOverrides)) {
          if (isObject(edgeOverride)) {
            migrateSplitLineEdgeOverride(edgeOverride);
          }
        }
      }
    }

    return json;
  },
};

export default migration;
